import { Redirect } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Status, useLoginPost } from "./authClient";
import { useAlert } from "react-alert";
import { JustifyCenterContainer } from "../../design-system/Container";
import { useAuthentication } from "../../auth-provider/AuthProvider";
import { HyperLink } from "../menuSpecificDashboard/DashboardDesign";
import {
  Box,
  Button,
  Container,
  Divider,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import GoogleSignInImg from "../img/google-btn.png";
import { CSRFToken } from "./CSRFToken";

export const LoginForm = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const { token, status, setLogin } = useLoginPost();
  const alert = useAlert();
  const isEmailAndPassValid = email && password;
  const { setToken } = useAuthentication();

  const handleEmailChange = (emailFromInput: string) => {
    setEmail(emailFromInput);
  };

  const handlePasswordChange = (passwordFromInput: string) => {
    setPassword(passwordFromInput);
  };

  useEffect(() => {
    status === Status.Error && alert.error("Request Failed");
    status === Status.AuthError && alert.error("Incorrect Email or Password");
  }, [status, alert]);

  useEffect(() => {
    token && setToken(token);
  }, [token, setToken]);

  const handleSubmit = () => {
    isEmailAndPassValid || alert.error("Incorrect email or password.");
    isEmailAndPassValid && setLogin({ email: email, password: password });
  };

  const onKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="calc(100vh - 60px)"
      px={2}
    >
      {status === Status.Success && (
        <Redirect to={{ pathname: "/dashboard/menu" }} />
      )}
      <Paper
        elevation={4}
        sx={{ maxWidth: 440, width: "100%", borderRadius: 3, p: 5 }}
      >
        <Typography variant="h5" fontWeight={700} align="center" gutterBottom>
          Welcome back
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mb: 3 }}
        >
          Log in to manage your restaurant menu
        </Typography>

        <Container disableGutters>
          <JustifyCenterContainer width="100%;">
            <TextField
              fullWidth
              label={"Email"}
              placeholder={"Email"}
              variant={"standard"}
              type={"email"}
              onChange={(event) => {
                handleEmailChange(event.target.value);
              }}
              onKeyPress={onKeyPress}
            />
          </JustifyCenterContainer>

          <JustifyCenterContainer width="100%;">
            <TextField
              fullWidth
              variant={"standard"}
              placeholder="Password"
              label={"Password"}
              type="password"
              onChange={(event) => {
                handlePasswordChange(event.target.value);
              }}
              onKeyPress={onKeyPress}
            />
          </JustifyCenterContainer>

          <Button
            onClick={handleSubmit}
            aria-label="login-button"
            data-testid="test-id-login-button"
            variant={"contained"}
            fullWidth
            size="large"
            sx={{ mt: 3 }}
          >
            Log in
          </Button>

          <Divider sx={{ my: 2 }}>
            <Typography variant="caption" color="text.secondary">
              OR
            </Typography>
          </Divider>

          <form action={"/accounts/google/login/"} method="post">
            <CSRFToken />
            <Button
              data-testid="test-id-google-login-button"
              type="submit"
              fullWidth
              sx={{ p: 0 }}
            >
              <img
                src={GoogleSignInImg}
                alt="Log in with google"
                style={{ width: "100%", maxWidth: 240 }}
              />
            </Button>
          </form>

          <Box textAlign="center" mt={2}>
            <HyperLink
              onClick={() => {
                window.open("reset-password/", "_self");
              }}
            >
              Forgot password?
            </HyperLink>
          </Box>

          <Box textAlign="center" mt={1.5}>
            <Typography variant="body2" component="span">
              New to OrderIt?{" "}
            </Typography>
            <HyperLink
              onClick={() => {
                window.open("signup/", "_self");
              }}
            >
              Sign up free
            </HyperLink>
          </Box>
        </Container>
      </Paper>
    </Box>
  );
};
